import api from "lib/api";

export const getCreditRemainder = async (params = {}) => {
    return await api.post("/v1/webapp/creditRemainder", params);
};

export const getRequestLoanList = async (params = {}) => {
    return await api.post("/v1/webapp/getRequestLoanList", params);
};

export const getRequestLoanListByCompany = async (params = {}) => {
    return await api.post("/v1/webapp/getRequestLoanListByCompany", params);
};

export const getLoanDetails = async (params = {}) => {
    return await api.post("/v1/webapp/getLoanDetails", params);
};

export const getVerifyLoanRequest = async (params = {}) => {
    return await api.post("/v1/webapp/verifyLoanRequest", params);
};
export const getCreateRequestLoan = async (params = {}) => {
    return await api.post("v1/webapp/createRequestLoan", params);
};
export const getProfile = async (params = {}) => {
    return await api.post("v1/webapp/profile", params);
};

export const getRequestOtp = async (params = {}) => {
    return await api.post("v1/webapp/requestOtp", params);
};

export const getVerifyOtp = async (params = {}) => {
    return await api.post("v1/webapp/verifyOtp", params);
};